import { render, staticRenderFns } from "./LoadingSsoLogin.vue?vue&type=template&id=4868c704&scoped=true"
import script from "./LoadingSsoLogin.vue?vue&type=script&lang=js"
export * from "./LoadingSsoLogin.vue?vue&type=script&lang=js"
import style0 from "./LoadingSsoLogin.vue?vue&type=style&index=0&id=4868c704&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4868c704",
  null
  
)

export default component.exports